import React from 'react'
import { connect } from 'react-redux'
import styles from './Msg.module.css';

class PatientHomePeerReviewMsg extends React.Component {

    render() {
        return (
            <div className={styles.msg_wrapper}>
                <div className={styles.msg_header}>
                    <span className={styles.msg_header_text}>
                        {this.props.msg.dateTime + ' - Message by ' + this.props.msg.user}
                    </span>
                </div>
                <div className={styles.msg_body}>
                    {this.props.msg.note}
                </div>
            </div>
        )
    }
}

function mapStateToProps(state, ownprops) {
    return {
        msg: state.entities.peerReviewMsgs[ownprops.id]
    };
}

const connectedPatientHomePeerReviewMsg = connect(mapStateToProps)(PatientHomePeerReviewMsg);
export { connectedPatientHomePeerReviewMsg as PatientHomePeerReviewMsg };

